import React from "react";

const GraphQLErrors = (props) => {

  if (props.error) {
    return (
      <pre>Bad: {props.error.graphQLErrors.map(({ message }, i) => (
        <span key={i}>{message}</span>
      ))}</pre>
    )
  }

  return null;

}

export default GraphQLErrors;